module.exports = __webpack_public_path__ + "static/img/conversation_2.7d9623a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/conversation_2.png
// module id = uj03
// module chunks = 1